/**
 * Dynamically get the height of the header so it's not reliant on an arbitrary number that could change
 */
export function getStickyHeaderHeight() {
  const stickyHeaders = Array.from(
    document.getElementsByClassName("stickyHeader"),
  );

  // sum every visible one - the stack can be a pinned message, the latest order
  // banner and the header itself. Hidden variants (eg mobile vs desktop)
  // measure 0 and drop out
  let totalHeight = 0;
  for (const stickyHeader of stickyHeaders) {
    totalHeight += stickyHeader.getBoundingClientRect().height;
  }

  return totalHeight;
}
